import React, { useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { useQuery, useQueryParam } from '@chilecompra/react-kit'
import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'

import { onClosePublishQuoteDialog, onPublishQuoteRequestThunk } from './PublishQuoteDialog.actions'

import { DialogWrapper, Row } from './PublishQuoteDialog.styles'

import routes from '../../config/settings/routes'
import { inIframe } from '../../modules/utils/inIframe'
import { topPage } from '../../modules/utils/topPage'

/**
 * The PublishQuoteDialog's container.
 */
const PublishQuoteDialog = () => {
  const { loading, showPublishQuoteDialog } = useSelector(state => state.publishQuoteDialog)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const query = useQuery()
  const quoteCode = useQueryParam('quote')

  const isInIframe = useMemo(() => inIframe(), [])

  const handleClickCloseDialog = () => dispatch(onClosePublishQuoteDialog())

  const handlePublishQuoteRequest = () => {
    dispatch(
      onPublishQuoteRequestThunk({
        quoteCode,
        callback: payload => {
          query.set('quote', quoteCode)
          navigate(
            { pathname: routes.quoteRequestPublishedSuccessfully, search: query.toString() },
            { replace: true, state: { effectiveDays: payload.quoteEffectiveDays } }
          )
        }
      })
    )
  }

  useEffect(() => topPage(isInIframe, showPublishQuoteDialog), [showPublishQuoteDialog])

  return (
    <Dialog disableBackdropClick open={showPublishQuoteDialog} verticalAlign="top" onClose={handleClickCloseDialog}>
      <DialogWrapper>
        <Row>
          <Typography fontWeight="bold" variant="h4">
            Estás a punto de publicar una solicitud de cotización
          </Typography>
          <Typography margin="16px 0 0" variant="body2">
            Una vez publicada, tu solicitud no podrá ser editada y sólo podrás ampliar el plazo de cierre.
          </Typography>
        </Row>
        <Row>
          <Button
            color="success"
            disabled={loading}
            loading={loading}
            onClick={handlePublishQuoteRequest}
            variant="contained"
          >
            Publicar solicitud
          </Button>
        </Row>
        <Row>
          <Button onClick={handleClickCloseDialog} variant="text">
            Cancelar
          </Button>
        </Row>
      </DialogWrapper>
    </Dialog>
  )
}

export default PublishQuoteDialog
